<template>
    <div>

        <button class="btn btn-primary" @click="openModal">Exportar para Excel</button>


        <div class="modal fade" id="modal-excel" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Selecione uma data de início e uma data fim, para gerar o relatório.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>


                        <div class="modal-body">
                            <div class="form-group">
                                <label>Data de início</label>
                                <input type="date" v-model="data_de" name="data_de" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Data de Fim</label>
                                <input type="date" v-model="data_ate" name="data_ate" class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Situação</label>
                                <select v-model="status" class="form-control" name="status">
                                    <option value=""> Todos </option>
                                    <option value="A">ABERTO</option>
                                    <option value="B">PAGO</option>
                                </select>
                            </div>

                            <div>
                                <label>Digite o codigo do distribuidor.</label>
                                <v-select v-model="distribuidor" :options="listaDistribuidor"  :onSearch="loadDistribuidor"></v-select>
                            </div>

                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                            <button type="submit" class="btn btn-primary" @click="geraExel">Gerar Relatório</button>
                        </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "Excel.vue",
        data() {
            return{
                data_de: '',
                data_ate: '',
                status: '',
                distribuidor: '',
                listaDistribuidor: ''
            }
        },
        methods: {
            openModal:function(){
                this.data_de = "";
                this.data_ate = "";
                this.distribuidor = "";
                this.status = "";
                $('#modal-excel').modal();
            },
            loadDistribuidor:function(key){

                var vm = this;
                this.listaDistribuidor = [];
                axios.get('/adm/distribuidores/combo',{ params: {query:key} }).then(function (response) {

                    console.log(response.data);
                    var obj = response.data;
                    obj.forEach(function (v) {
                        vm.listaDistribuidor.push({value:v.id,label:v.codigo+' - '+v.nome});
                    });

                }).catch(function (error) {
                    console.log(error);
                });
            },
            geraExel:function(){
                var vm = this;
                if(this.distribuidor === ""){
                    vm.$swal('Informe um distribuidor','','error');
                }
                var data = {
                    data_de: this.data_de,
                    data_ate: this.data_ate,
                    distribuidor: this.distribuidor.value
                }
                $('.loading').show();
                axios({
                    method: 'post',
                    url: '/adm/comissoes',
                    responseType: 'blob',
                    data: data
                }).then(function (response) {
                    let file = new Blob([response.data], { type: "application/vnd.ms-excel"});
                    let url = window.URL.createObjectURL(file);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = Date.now()+ ".xls";
                    a.click();
                    window.URL.revokeObjectURL(url);

                    $('#modal-excel').modal('hide');
                    $('.loading').hide();

                }).catch( erro => {
                    $('.loading').hide();
                    vm.$swal('Ops', erro, 'error');
                })
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/adm_comissoes/Excel.vue